export const TESTING_SET_CREATED_TEXTURES = 'TESTING_SET_CREATED_TEXTURES';
export const testingSetCreatedTextures = (textures) => ({ type: TESTING_SET_CREATED_TEXTURES, payload: textures });

export const TESTING_SET_TESTED_TEXTURE = 'TESTING_SET_TESTED_TEXTURE';
export const testingSetTestedTexture = (texture) => ({ type: TESTING_SET_TESTED_TEXTURE, payload: texture });
